import { jsx as _jsx } from "react/jsx-runtime";
import emojiData from "@emoji-mart/data";
import { useEffect, useRef } from "react";
export function EmojiMartPicker({ onEmojiSelect, theme = "light", previewPosition, searchPosition, skinTonePosition, }) {
    const containerRef = useRef(null);
    useEffect(() => {
        let cancelled = false;
        let picker = null;
        void import("emoji-mart").then(({ Picker }) => {
            if (cancelled || !containerRef.current)
                return;
            picker = new Picker({
                data: emojiData,
                theme,
                previewPosition,
                searchPosition,
                skinTonePosition,
                onEmojiSelect: (emoji) => {
                    const nativeEmoji = typeof (emoji === null || emoji === void 0 ? void 0 : emoji.native) === "string" ? emoji.native : "";
                    if (nativeEmoji) {
                        onEmojiSelect(nativeEmoji);
                    }
                },
            });
            containerRef.current.replaceChildren(picker);
        });
        return () => {
            var _a, _b;
            cancelled = true;
            (_a = picker === null || picker === void 0 ? void 0 : picker.remove) === null || _a === void 0 ? void 0 : _a.call(picker);
            (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.replaceChildren();
        };
    }, [onEmojiSelect, previewPosition, searchPosition, skinTonePosition, theme]);
    return _jsx("div", { ref: containerRef });
}
